import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { Section } from '../section/section';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { ProductMenu } from '../product-menu';
import { ColWidth } from '../../shared/col-width';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class LaCanapaMenu extends ProductMenu {
  getThemeClass(): string {
    return 'la-canapa-theme';
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/cqp5xic.css';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getShowHeader(): boolean {
    return true;
  }

  getShowFooter(): boolean {
    return false;
  }

  getSectionHeaderUnderlined(): boolean {
    return true;
  }

  getSectionTitleUnderlineColor(section: Section): string {
    return '#731818';
  }

  getTitleSectionTopMargin(): string {
    return '0';
  }

  getTitleSectionBottomMargin(): string {
    return '0.5rem';
  }

  override getThemeSpecifiedColumnViewModels(
    sectionRowViewModels: SectionRowViewModel[],
    sectionRowViewModel: SectionRowViewModel,
    widths: ColWidth[] = this.getColWidths(sectionRowViewModel)
  ): SectionColumnViewModel[] {
    const vms = super.getThemeSpecifiedColumnViewModels(sectionRowViewModels, sectionRowViewModel, widths);
    if (!sectionRowViewModel.hideLabel) {
      const layoutType = sectionRowViewModel?.getLayoutType();
      const labelCol = new SectionColumnViewModel(layoutType, null);
      labelCol.columnType = SectionColumnProductInfoType.Label;
      labelCol.columnTitle = '';
      labelCol.widthPercentage = '10';
      vms.splice(0, 0, labelCol);
    }
    return vms;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.Label, 0],
      [SectionColumnProductInfoType.StrainType, 1],
      [SectionColumnProductInfoType.ProductTitle, 2],
      [SectionColumnProductInfoType.Brand, 3],
      [SectionColumnProductInfoType.Badge, 4],
      [SectionColumnProductInfoType.Strain, 5],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(6),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(8),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(9),
      [SectionColumnProductInfoType.QuantityAndSize, 10],
      [SectionColumnProductInfoType.Quantity, 11],
      [SectionColumnProductInfoType.Size, 12],
      [SectionColumnProductInfoType.GradingResults, 13],
      [SectionColumnProductInfoType.VariantPrice, 14],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 15]
    ]);
  }

  getShouldInflateColumnHeaderForRow(s: Section, col: SectionColumnViewModel, rows: SectionRowViewModel[]): boolean {
    const label = col?.columnType === SectionColumnProductInfoType.Label;
    const classification = col?.columnType === SectionColumnProductInfoType.StrainType;
    return !label && !classification;
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getShowInlineLabels(): WithinNameCell | null {
    return null;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.OpenSans.Bold_700, FONT.OpenSans.Regular_400, FONT.OpenSans.SemiBold_600, FONT.OpenSans.ExtraBold_800];
  }
}
